export const SIGNING_FLOW_TYPE_MAP = {
    signIn: {
        name: 'login',
        eventName: 'Sign In',
    },
    signUp: {
        name: 'join',
        eventName: 'Sign Up',
    },
    socialSignUp: {
        eventName: 'Social Sign Up',
    },
    social: {
        name: 'social',
        eventName: 'Social',
    },
} as const;

export type SigningFlowType = ValueOf<typeof SIGNING_FLOW_TYPE_MAP>;
